// The catalog has no `image` field (shared/catalog/products.json) and none
// is added — a demo repo has no business sourcing/licensing real product
// photos. One emoji per category stands in for a photo on the product card;
// an unrecognised category (a catalog change this file hasn't caught up
// with) falls back to a generic box rather than rendering nothing.
const ICONS: Record<string, string> = {
  Audio: "🎧",
  Fitness: "🏋️",
  Home: "🏠",
  Kitchen: "🍳",
  Office: "💼",
  Outdoor: "⛺",
};

export function categoryIcon(category: string): string {
  return ICONS[category] ?? "📦";
}
